function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNothingFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 247 197",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M219.092,169.316l0,-42",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.092,73.316l-96,-24l0,48l96,-24Z",
    style: {
      fillOpacity: 0.16
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.092,193.316l0,-96m0,96l-96,-24l0,-42m96,66l96,-24m-96,-72l-96,-24m96,24l-24,48c-37.563,-9.382 -58.436,-14.618 -96,-24l24,-48m96,24l24,48l96,-24l-24,-48m-96,24l96,-24m-96,24l0,-48m-96,24l96,-24m0,-0l96,24",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.632,17.502c-0.283,0.771 -1.216,1.417 -2.86,1.631c-1.604,0.207 -3.679,-0.038 -5.825,-0.826c-2.145,-0.788 -3.886,-1.944 -4.974,-3.14c-1.116,-1.226 -1.409,-2.323 -1.125,-3.094c0.283,-0.772 1.216,-1.418 2.86,-1.631c1.604,-0.208 3.679,0.037 5.825,0.825c2.145,0.788 3.886,1.944 4.974,3.14c1.115,1.226 1.409,2.323 1.125,3.095Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.61,6.799c0.022,1.115 -0.262,2.096 -0.699,2.78c-0.441,0.689 -0.979,1.003 -1.479,1.012c-0.499,0.01 -1.049,-0.284 -1.515,-0.955c-0.463,-0.666 -0.784,-1.636 -0.806,-2.751c-0.021,-1.115 0.263,-2.097 0.701,-2.78c0.44,-0.689 0.978,-1.003 1.478,-1.012c0.499,-0.01 1.049,0.283 1.516,0.955c0.462,0.666 0.783,1.636 0.804,2.751Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.342,9.552c-0.571,0.958 -1.33,1.642 -2.061,1.992c-0.738,0.353 -1.36,0.336 -1.79,0.081c-0.429,-0.256 -0.742,-0.795 -0.784,-1.612c-0.041,-0.81 0.197,-1.803 0.767,-2.762c0.57,-0.958 1.329,-1.642 2.061,-1.992c0.738,-0.353 1.361,-0.336 1.79,-0.08c0.43,0.255 0.742,0.794 0.784,1.611c0.042,0.81 -0.197,1.803 -0.767,2.762Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.778,92.816c-16.686,-28.125 22.721,-43.799 42.564,-47.25c21.361,-3.93 30.75,-23.625 6.375,-28.125",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.5px",
      strokeDasharray: "6,6"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNothingFound);
export default __webpack_public_path__ + "static/media/nothing_found.fea5674e5f85380fac9df7ed2fd64f6c.svg";
export { ForwardRef as ReactComponent };